<!-- Dialog for deleting a study table record -->
<mat-dialog-content class="mat-typography" style="color:#003865">

    <h1>Delete Study "{{studyName}}"?</h1>

        <!-- Study name -->
        <div>
            <mat-form-field style="width:75%;color:darkgrey;font-style:italic;">
                <mat-label>Study Name</mat-label>
                <input matInput [(ngModel)]="studyName" readonly tabindex="-1">
            </mat-form-field>
        </div>

        <!-- Study remarks -->
        <div>
            <mat-form-field style="width:75%;color:darkgrey;font-style:italic;">
                <mat-label>Remarks</mat-label>
                <input matInput [(ngModel)]="studyRemarks" readonly tabindex="-1">
            </mat-form-field>
        </div>

</mat-dialog-content>

<!-- Buttons -->
<mat-dialog-actions align="end">
    <!-- Delete study button -->
    <button mat-raised-button color="warn" (click)="deleteStudy()" mat-dialog-close>Delete</button>
    <!-- Close button -->
    <button mat-raised-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>
